<template>
  <RouterLink
    :to="path"
    :style="`background-image: url('${card.image.sizes.thumbnail}')`"
    class="relative block h-40vw md:h-30vw lg:h-20vw xl:h-16vw w-44vw lg:w-25vw xl:w-19vw mb-2vw lg:mb-0 bg-cover bg-center shadow-lg font-medium"
  >
    <div class="overflow-hidden w-full h-full">
      <img
        v-if="browser !== 'IE' && !mobile"
        :src="card.image.sizes.thumbnail"
        :alt="card.image.alt"
        class="object-cover w-full h-full mobile-landscape:hidden"
        :class="{ 'hover:zoom transition': !touch }"
      >
    </div>
    <div class="absolute bottom-0">
      <span
        class="inline-flex items-center px-2 pt-2 pb-1 md:px-3 bg-white text-primary text-xs md:text-sm xxl:text-base"
      >
        {{ card.typeHeading }}
        <IconBase
          :icon="`icon${card.type}`"
          :size="!mobile ? '18px' : '15px'"
          class="ml-2 mb-px"
        />
      </span>

      <br>

      <span
        class="inline-block px-2 py-1 md:px-3 md:pb-1 bg-white"
      >
        <h2
          class="text-xs md:text-base xxl:text-lg"
          v-html="card.title"
        />
      </span>
    </div>
  </RouterLink>
</template>

<script>
import { mapState } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'Card',

  components: {
    IconBase
  },

  props: {
    card: {
      type: Object,
      default: () => {}
    },
    path: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState([ 'mobile', 'touch', 'browser' ])
  }
}
</script>
